module.exports = __webpack_public_path__ + "static/betreiber-be37c64b3a6f86900374213b7e8bc012.svg";